export enum Theme {
  PurplePink = 'purplePink',
  BlueGreen = 'blueGreen',
  OrangeYellow = 'orangeYellow',
  BluePurple = 'bluePurple',
  PinkRed = 'pinkRed',
  none = 'none',
}

export enum BtnVariant {
  'button-primary' = 'button-primary',
  'button-secondary' = 'button-secondary',
  'button-tertiary' = 'button-tertiary',
}

export enum Background {
  'none' = '',
  'red' = 'red',
  'plum' = 'plum',
  'grey' = 'grey',
  'black' = 'black',
}

export enum CopyStyle {
  'none' = '',
  'bold' = 'bold',
}
